// UserProvider.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { AuthContext } from "../../App";

const UserContext = createContext(null);

export const useUser = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setLoading(false);
        return;
      }

      const setColors = (colorsArray) => {
        const colors = [
          { variable: "--main-hue", value: colorsArray[0] },
          { variable: "--main-contrast", value: colorsArray[1] + "%" },
          { variable: "--main-brightness", value: colorsArray[2] + "%" },
          { variable: "--secondary-hue", value: colorsArray[3] },
          { variable: "--secondary-contrast", value: colorsArray[4] + "%" },
          { variable: "--secondary-brightness", value: colorsArray[5] + "%" },
        ];

        colors.map((color, index) => {
          document.documentElement.style.setProperty(
            color.variable,
            color.value
          );
        });
      };

      // Load colors from localStorage while waiting for database
      const localStorageColors = JSON.parse(localStorage.getItem("userColors"));
      if (localStorageColors) {
        setColors(localStorageColors);
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/users/me`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();
        setLoading(false);

        if (response.ok) {
          setUser(data);
          console.log("Connecté avec succès !");

          // Save colors to localStorage
          if (data.Colors) {
            localStorage.setItem("userColors", JSON.stringify(data.Colors));
            setColors(data.Colors);
          }
        } else {
          console.error("Error:", data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    if (isAuthenticated) {
      fetchUser();
    } else {
      setUser(null);
      setLoading(false);
    }
  }, [isAuthenticated]);

  const logout = () => {
    setUser(null);
    localStorage.removeItem("userColors");
  };

  return (
    <UserContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </UserContext.Provider>
  );
};
